<script>
export default {
  name: 'ToolButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: { type: String, required: true },
    size: { type: [Number, String], default: 40 },
    buttonClass: [String, Array, Object],
    tooltipLocation: { type: String, default: 'right' },
    disabled: { type: Boolean, default: false },
    availability: {
      type: String,
      default: null,
      validator: v =>
        v === null || ['ready', 'busy', 'inactive', 'error'].includes(v),
    },
  },

  computed: {
    sizeV() {
      return Number(this.size);
    },
    iconSize() {
      return Math.floor(0.6 * this.sizeV);
    },
    isMdiIcon() {
      return (
        typeof this.icon === 'string' && this.icon.trim().startsWith('mdi')
      );
    },
  },
};
</script>

<template>
  <v-btn
    variant="text"
    :rounded="0"
    theme="dark"
    :height="sizeV"
    :width="sizeV"
    :min-width="sizeV"
    :max-width="sizeV"
    v-bind="$attrs"
    :disabled="disabled"
    class="tool-button"
  >
    <template v-if="isMdiIcon">
      <v-icon :size="iconSize" class="default-icon">
        {{ icon }}
      </v-icon>
    </template>
    <template v-else>
      <img
        :src="icon"
        :style="{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          objectFit: 'contain',
          flexShrink: 0,
        }"
        alt="icon"
      >
    </template>
    <v-tooltip
      :location="tooltipLocation"
      activator="parent"
      transition="slide-x-transition"
    >
      <span>{{ label }}</span>
    </v-tooltip>
    <div
      v-if="availability"
      class="availability-indicator"
      :class="[`availability-${availability}`]"
    />
    <slot />
  </v-btn>
</template>

<style scoped>
.tool-button {
  position: relative;
  padding: 0 !important;
}

.availability-indicator {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.availability-ready {
  background-color: var(--md-success);
}

.availability-busy {
  background-color: var(--md-warning);
}

.availability-inactive {
  background-color: var(--md-on-surface-variant);
}

.availability-error {
  background-color: var(--md-error);
}
.tool-button img {
  width: v-bind('`${iconSize}px`');
  height: v-bind('`${iconSize}px`');
  object-fit: contain;
}
</style>
